import { E } from "@scripts/fp-ts";
import * as p from "@scripts/generated/domaintables/pages";
import { SitesJumpLink } from "@scripts/react/components/SidebarLinks";
import { projectsMeta } from "@scripts/routes/routing/issuerportal/dataMeta";

export const allStatic: ReadonlyArray<SitesJumpLink> = [SitesJumpLink(projectsMeta, [E.right(p.infrastructureProjects)])];
